<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="chap1">ALIVE</p>
<p class="chap_line"></p>
<p class="center"><span class="big">B</span>eing thrust from heaven is where Satan’s utter hatred for our salvation’s plan is derived</p>
<p class="center">And like the wanted posters of old, he will do anything to get your soul, dead or alive.</p>
<p class="center1">All souls are important to God the Father, and He sends His shepherds to guide the flocks of souls back to heaven’s gate</p>
<p class="center">And He goes to extraordinary lengths so the utterly lost are not ever left alone and to suffer a most terrible fate.</p>
<p class="center1">Christ’s plan of salvation came with God the Father’s consent</p>
<p class="center">So that every soul, born of the flesh, can return from whence they were sent.</p>
<p class="center1">We all live our lives whether long or short</p>
<p class="center">And with true repentance will return with our eternal mate and to our eternal family report.</p>
<p class="center1">Christ the Savior’s sacrifice will not ever be in vain</p>
<p class="center">If we choose to grasp God’s iron rod to ensure our return to the highest heavenly plane.</p>
<p class="center1">Being thrust from heaven is where Satan’s utter hatred for our salvation’s plan is derived</p>
<p class="center">And like the wanted posters of old, he will do anything to get your soul, dead or alive.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap007.vue?06f1cd25